<template>
    <div class="goods-shoot-content">
        <div>
            <div class="goods-shoot-header">
                <span style="margin-bottom: 28px;">素材下载</span>
            </div>
            <div class="task-table">
                <div class="table-title">
                    <span class="text">任务详情</span>
                    <span class="text">素材下载</span>
                    <span class="text">商品视频（支持拓展名：rar和zip，文件大小不能超过100M）</span>
                </div>
                <div class="table-body">
                    <span class="text">商品视频拍摄与处理</span>
                    <span class="text">点击下载</span>
                    <div class="upload text">
                        <el-button plain onclick="uploadFile.click()">选择文件</el-button>
                        <input class="file-upload-btn" ref="uploadFile" id="uploadFile" type="file"
                               accept="application/zip, .rar" title=""
                               @change="changeFile($event)">
                        <span class="upload-text">{{filesName}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div  style="text-align: center">
            <el-button type="primary" @click="saveGoodsVideoShoot">提交</el-button>
        </div>
    </div>
</template>

<script>
    import  Upload from '@/utils/slice_upload';
    import {uploadMaterial, mergeSlice} from '@/utils/apis'
    export default {
        name: "GoodsVideoShoot",
        data() {
          return {
              //文件名称
              filesName: '未选择任何文件',
              //分片上传
              uploadInstance: null
          }
        },
        methods: {
            //上传素材
            changeFile(event) {
                let chunkSize = 1024 * 1024;
                let file = event.target.files[0];
                this.uploadInstance = new Upload(file, chunkSize, uploadMaterial);
                this.filesName = file.name;
                let index = 0;
                this.uploadSlice(index);
            },
            uploadSlice(index) {
                let num = this.uploadInstance.total_block_num;
                if (index === num && num !== 1) {
                    //合并分片
                    mergeSlice({
                        flag: this.uploadInstance.file_tmp,
                        slice_size: this.uploadInstance.block_size
                    }).then(res => {
                        if (res.code === 200) {
                            this.percent = 100;
                            this.$refs.uploadFile.value = null
                            this.$message.success(res.msg);
                        }
                    });
                    return;
                }
                this.uploadInstance.uploadSlice(index).then(res => {
                    if (res.code === 200) {
                        if (res.data.is_slice) { //is_slice 为true则为分片上传，后面需要合并分片,若为false则无须分片，或者文件大小<分片尺寸，直接上传就行
                            this.percent = Math.ceil((index / num) * 100);
                            this.uploadSlice(++index);
                        } else {
                            this.percent = 100;
                            this.$refs.uploadFile.value = null
                            this.$message.success(res.msg);
                        }
                    }
                });
            },
            //提交
            saveGoodsVideoShoot() {

            }
        }
    }
</script>

<style scoped lang="scss">
    .goods-shoot-content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
        padding: 20px;
        box-sizing: border-box;
        .goods-shoot-header {
            display: flex;
            justify-content: space-between;
            /*align-items: center;*/
            /*height: 58px;*/
            border-bottom: 2px solid #F1F5FF;
            span {
                color: #333;
                font-size: 16px;
            }
        }
    }
    .task-table {
        border: 1px solid #E5E5E5;
        margin-top: 16px;
        .table-title {
            display: flex;
            justify-content: space-between;
            width: 100%;
            height: 60px;
            line-height: 60px;
            background: #F6F6F6;
            border-bottom: 1px solid #EEEEEE;
            box-sizing: border-box;
            padding: 0 40px;
        }
        .text {
            display: inline-block;
            &:nth-child(1) {
                width: 200px;
            }
            &:nth-child(3) {
                width: 500px;
            }
        }
        .table-body {
            display: flex;
            justify-content: space-between;
            height: 70px;
            line-height: 70px;
            padding: 0 40px;
        }
    }
    .file-upload-btn {
        display: none;
    }
    .upload-text {
        color: #666;
        margin-left: 10px;
    }
    .is-plain {
        background: #FFF;
        border-color: #1CB064;
        color: #1CB064;
        border-radius: 2px;
    }
</style>